import React from "react";
import { Box } from "@mui/material";
import { useSharedStyles } from "../../styles/shared";

interface SectionEyebrowProps {
    label: string;
    className?: string;
}

const SectionEyebrow = (props: SectionEyebrowProps) => {
    const { classes, cx } = useSharedStyles();
    return (
        <Box component="span" className={cx(classes.eyebrow, props.className)}>
            {props.label}
        </Box>
    );
};

export default SectionEyebrow;
